export class UnitOption {
    public readonly id: string;
    public readonly title: string;
    public readonly isSiUnit: boolean;

    constructor(id: string, title: string, isSiUnit: boolean) {
        this.id = id;
        this.title = title;
        this.isSiUnit = isSiUnit;
    }

    public toString() {
        return this.title;
    }
}
